import React from 'react';
import { Icons } from '@Assets/SvgIcons';
import './TemplateLibraryButton.component.scss';

export interface TemplateLibraryButtonProps {
    handleOpen: () => void;
}

export const TemplateLibraryButton = ({
    handleOpen,
}: TemplateLibraryButtonProps) => {
  return (
    <button
        className="template-library-button"
        data-testid="template-library-button"
        onClick={handleOpen}
    >
        <Icons.Templates />
        <span>Template library</span>
    </button>
  )
}
